// extracted by mini-css-extract-plugin
export default {"formWrapper":"InternalCommentsForm_formWrapper__KnUIs","input":"InternalCommentsForm_input__hTmx7","submitButton":"InternalCommentsForm_submitButton__y6cbP"};